const ROUTE_NAME = Object.freeze({
  HOME: 'home',
  /*ARTICLE*/
  ARTICLE: 'article',
  ARTICLE_DETAIL: 'article-detail',
  /*PRODUCT*/
  PRODUCT_CATEGORY: 'product-category',
  PRODUCT_FLASH_DEALS: 'product-flash-deals',
  PRODUCT_HOT_DEALS: 'product-hot-deals',
  PRODUCT_BEST_SELLER: 'product-best-seller',
  PRODUCT_DETAIL: 'product-detail',
  PRODUCT_SEARCH: 'product-search',
  PRODUCT_WISH_LIST: 'product-wish-list',
  PRODUCT_AGENT_DEALS: 'product-agent-deals',
  /*ORDER*/
  ORDER_RETURN_PICKUP: 'order-return-pickup',
  ORDER_RETURN_PICKUP_ADDRESS: 'order-return-pickup-address',
  ORDER_REFUND: 'order-refund',
  ORDER_DETAIL: 'order-detail',
  ORDER_DELIVERY: 'order-delivery',
  ORDER_CHECK_OUT: 'order-check-out',
  ORDER_CART: 'order-cart',
  ORDER_DASHBOARD: 'order-dashboard',
  ORDER_ADDRESS_BOOK: 'order-address-book',
  ORDER_ADD_ADDRESS: 'order-add-address',
  ORDER_EDIT_ADDRESS: 'order-edit-address',
  ORDER_LIST: 'order-list',
  ORDER_PAYMENT: 'order-pay',
  ORDER_PAYMENT_SUCCESS: 'order-payment-success',
  /*APPOINT*/
  APPOINTMENT_MAKE_APPOINTMENT: 'appointment-make-appointment',
  APPOINTMENT_MY_APPOINTMENT: 'appointment-my-appointment',
  APPOINTMENT_DETAIL: 'appointment-detail',
  APPOINTMENT_EDIT_APPOINTMENT: 'appointment-edit-appointment',
  APPOINTMENT_COMPLETE: 'appointment-complete',
  /*AGENT*/
  AGENT_DASHBOARD: 'agent-dashboard',
  MEMBER_TRANSACTION_HISTORY: 'member-transaction-history',
  AGENT_CONVERT_POINT: 'agent-convert-point',
  AGENT_CONVERT_POINT_COMPLETE: 'agent-convert-point-complete',
  AGENT_TRANSFER_TO_BANK: 'agent-transfer-to-bank',
  AGENT_TRANSFER_TO_BANK_COMPLETE: 'agent-transfer-to-bank-complete',
  AGENT_ADD_BANK_ACCOUNT: 'agent-add-bank-account',
  AGENT_ONE_TIME_TRANSFER: 'agent-one-time-transfer',
  /*VOUCHER*/
  VOUCHER: 'voucher',
  VOUCHER_DETAILS: 'voucher-details',
  /*SALON INFO*/
  SALON_INFO_LIST: 'salon-listing',
  SALON_REVIEW: 'salon-review',
  /*TOS*/
  TERMS_OF_SERVICE: 'terms-of-service',
  AGENT_TERMS_OF_SERVICE: 'agent-terms-of-service',
  PRIVACY_POLICY: 'privacy-policy',
  /*PROFILE*/
  PROFILE: 'profile',
  PROFILE_ADDRESS_BOOK: 'profile-address-book',
  PROFILE_ADD_ADDRESS: 'profile-add-address',
  PROFILE_EDIT_ADDRESS: 'profile-edit-address',
  /*ADDRESS BOOK*/
  ADDRESS_BOOK: 'address-book',
  ADD_ADDRESS: 'add-address',
  /*PRODUCT REVIEW*/
  PRODUCT_REVIEW: 'product-review',
  PRODUCT_REVIEW_WRITE: 'product-review-write',
  /*WALLET*/
  WALLET: 'wallet',
  WALLET_VOUCHER_DETAILS: 'wallet-voucher-details',
  WALLET_POINT_TRANSFER: 'wallet-point-transfer',
  WALLET_POINT_TRANSFER_COMPLETE: 'wallet-point-transfer-complete',
  /*SALON STYLIST REVIEW*/
  SALON_STYLIST_REVIEW_NEW: 'salon-stylist-review-new',
  SALON_STYLIST_REVIEW_WRITE: 'salon-stylist-review-write',
  SALON_STYLIST_REVIEW_LIST: 'salon-stylist-review-list',
  SALON_STYLIST_REVIEW_COMPLETE: 'salon-stylist-review-complete'
})

export { ROUTE_NAME }
